/* eslint class-methods-use-this: "off" */
import { Controller } from '@hotwired/stimulus';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.pl';

export default class extends Controller {
  connect() {
    this.setupFields();
  }

  setupFields = () => {
    const phonesCollection = document.getElementsByClassName('phone-number-mask');
    Array.from(phonesCollection).forEach((phone) => {
      const cleave = new Cleave(phone, { phone: true, phoneRegionCode: 'PL' });
    });
  };
}
